import React from 'react';
import {
  AdvertiserDisclosure,
  PageContainer,
  CenteredContainer,
  Stack,
  Title,
  Box,
  List,
  Li,
  Text,
} from '@nerdwallet/currency';
import policies from '~/client/lib/company-content-src/privacy-policy-content';

import './privacy-policy.less';

const renderTitle = (title, level, size) => (
  <Text component={level} bold size={size}>
    {title}
  </Text>
);

const renderContent = (content) => (
  <React.Fragment>
    {content && (
      <Box className="privacy-policy-content">
        <Text>{content}</Text>
      </Box>
    )}
  </React.Fragment>
);

const renderList = (list) => (
  <React.Fragment>
    {list && (
      <List>
        {list.map((listItem) => (
          <Li>{listItem}</Li>
        ))}
      </List>
    )}
  </React.Fragment>
);

const renderBottomContent = (bottomContent) => (
  <React.Fragment>
    {bottomContent && <Text>{bottomContent}</Text>}
  </React.Fragment>
);

const PrivacyPolicyPage = () => (
  <PageContainer>
    <CenteredContainer>
      <Stack spacing={3}>
        <Box>
          <AdvertiserDisclosure />
          <Title className="privacy-policy-title">
            NerdWallet Candidate Privacy Policy
          </Title>
        </Box>
        <Text>Effective: September 21, 2021</Text>
        {policies.content.map((item) => (
          <React.Fragment>
            {renderTitle(item.title, 'h4', 'large')}
            {renderContent(item.content)}
            {renderList(item.list)}
            {item.secondLevelContent && (
              <Box paddingLeft="4">
                <Stack spacing={3}>
                  {item.secondLevelContent.map((secondLevelContent) => (
                    <React.Fragment>
                      {renderTitle(secondLevelContent.title, 'h5', 'default')}
                      {renderContent(secondLevelContent.content)}
                      {renderList(secondLevelContent.list)}
                      {secondLevelContent.thirdLevelContent && (
                        <Box paddingLeft="4">
                          <Stack spacing={3}>
                            {secondLevelContent.thirdLevelContent.map(
                              (lastLevel) => (
                                <React.Fragment>
                                  {renderTitle(
                                    lastLevel.title,
                                    'h5',
                                    'default'
                                  )}
                                  {renderContent(lastLevel.content)}
                                  {renderList(lastLevel.list)}
                                  {renderBottomContent(lastLevel.bottomContent)}
                                </React.Fragment>
                              )
                            )}
                          </Stack>
                        </Box>
                      )}
                      {renderBottomContent(secondLevelContent.bottomContent)}
                    </React.Fragment>
                  ))}
                </Stack>
              </Box>
            )}
          </React.Fragment>
        ))}
      </Stack>
    </CenteredContainer>
  </PageContainer>
);

PrivacyPolicyPage.displayName = 'PrivacyPolicyPage';
PrivacyPolicyPage.analyticsName = 'privacypolicy_page';
PrivacyPolicyPage.segmentPageName = 'privacy_policy';

export default PrivacyPolicyPage;
